<template>
    <!-- Button to trigger new messages (for demo) -->
    <!-- <v-btn @click="addMessage" color="primary" class="ma-4">
      Show New Message
    </v-btn> -->

    <div class="message-stack">
      <v-alert
        :value="alert"
        color="warning"
        dark
        border="top"
        icon="mdi-information"
        transition="scale-transition"
      >
        
        <div class="d-flex align-center">
            <span>{{ messageData }} <a  @click.prevent="navigateToMessageCenter">Click here to go to the message center</a></span>
            <v-spacer></v-spacer>
            <v-btn icon small @click="closeMessage()">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
      </v-alert>
    </div>

    <!-- Message container -->
    <!-- <div class="message-stack">
      <transition-group name="slide-fade">
        <v-alert
          v-for="(msg, index) in messages"
          :key="msg.id"
          :color="msg.color"
          dark
          border="left"
          elevation="99"
          class="mb-2 message-alert"
        >
          <div class="d-flex align-center">
            <span>{{ msg.text }}</span>
            <v-spacer></v-spacer>
            <v-btn icon small @click="closeMessage(msg.id)">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-alert>
      </transition-group>
    </div> -->
</template>

<script>
import signalRService from '@/services/signalR'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('authenticate')

export default {
  data() {
    return {
      alert: false,
      messageData: null,
      messages: [],
      colors: ['primary', 'teal', 'purple', 'indigo'], // Different colors for demo
      messageCount: 0,
      texts: [
      ],
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  methods: {
    addMessage(data) {
      this.messageData = data
      this.alert = true
      // const colorIndex = this.messageCount % this.colors.length
      // const textIndex = this.messageCount % this.texts.length
      
      // this.messages.push({
      //   id: Date.now() + this.messageCount,
      //   text: this.texts[textIndex],
      //   color: this.colors[colorIndex],
      // })
      
      // this.messageCount++
    },
    closeMessage() {
      this.alert = false
      //this.messages = this.messages.filter(msg => msg.id !== id)
    },
    setupNotifications() {
      this.notificationEnabled = true
      
      // Register notification handler
      signalRService.registerNotificationHandler(this.handleNotification)
      
      signalRService.startConnection(this.currentUser.userId)
      // Start SignalR connection
      // if (this.currentUser && this.currentUser.id) {
      //   signalRService.startConnection(this.currentUser.id)
      // }
    },

    handleNotification(message) {
      this.messageData = message
      this.alert = true
      // if (document.hidden) {
      //   // Show browser notification only when tab is not active
      //   this.showBrowserNotification(message)
      // } else {
      //   // Show in-app notification when tab is active
      //   this.showInAppNotification(message)
      // }
    },
    navigateToMessageCenter() {
      this.$router.push({
        name: 'MessageCenter',              
      })
    },
  },
  async mounted() {
    
    // Check existing permission
    this.setupNotifications()

    //this.addMessage()
    
  },
  beforeDestroy() {
    signalRService.stopConnection()
  },
}
</script>

<style scoped>
.message-stack {
  position: fixed;
  top: 50px;
  right: 20px;
  z-index: 1000;
  max-width: 450px;
  width: 100%;
}

.message-alert {
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

/* Animation for message entry/exit */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(100px);
  opacity: 0;
}
</style>